export class WorkspaceManager {

    constructor(options = {}) {

        const {
            httpClient,
            resourcePath = 'projects/workspaces',
        } = options;

        if (!httpClient)
            throw new Error('[WorkspaceManager]: "httpClient" is required.');

        this.http = httpClient;
        this.resourcePath = String(resourcePath).replace(/^\/+|\/+$/g, '');

    }

    async queryUserWorkspaces() {

        return this.get('user');

    }

    async getCurrentWorkspace() {

        return this.get('current');

    }

    async getAllWorkspaceProjects(workspaceUid) {

        if (!workspaceUid)
            throw new Error('[WorkspaceManager]: "workspaceUid" is required.');

        return this.get(`${encodeURIComponent(workspaceUid)}/projects`);

    }

    async getWorkspaceProject(workspaceUid, projectUid) {

        if (!workspaceUid)
            throw new Error('[WorkspaceManager]: "workspaceUid" is required.');
        if (!projectUid)
            throw new Error('[WorkspaceManager]: "projectUid" is required.');

        return this.get(`${encodeURIComponent(workspaceUid)}/projects/${encodeURIComponent(projectUid)}`);

    }

    async getWorkspaceProjectDetails(workspaceUid, projectUid) {

        if (!workspaceUid)
            throw new Error('[WorkspaceManager]: "workspaceUid" is required.');
        if (!projectUid)
            throw new Error('[WorkspaceManager]: "projectUid" is required.');

        return this.get(`${encodeURIComponent(workspaceUid)}/projects/${encodeURIComponent(projectUid)}/details`);

    }

    async getAllWorkspaceProjectModelSections(workspaceUid, projectUid) {

        if (!workspaceUid)
            throw new Error('[WorkspaceManager]: "workspaceUid" is required.');
        if (!projectUid)
            throw new Error('[WorkspaceManager]: "projectUid" is required.');

        return this.get(`${encodeURIComponent(workspaceUid)}/projects/${encodeURIComponent(projectUid)}/model-sections`);

    }

    async getWorkspaceProjectModelSection(workspaceUid, projectUid, modelSectionUid) {

        if (!workspaceUid)
            throw new Error('[WorkspaceManager]: "workspaceUid" is required.');
        if (!projectUid)
            throw new Error('[WorkspaceManager]: "projectUid" is required.');
        if (!modelSectionUid)
            throw new Error('[WorkspaceManager]: "modelSectionUid" is required.');

        return this.get(`${encodeURIComponent(workspaceUid)}/projects/${encodeURIComponent(projectUid)}/model-sections/${encodeURIComponent(modelSectionUid)}`);

    }

    async createWorkspaceProject(workspaceUid, data) {

        if (!workspaceUid)
            throw new Error('[WorkspaceManager]: "workspaceUid" is required.');
        if (!data)
            throw new Error('[WorkspaceManager]: project data are required.');

        return this.post(`${encodeURIComponent(workspaceUid)}/projects`, data);

    }

    async deleteWorkspaceProject(workspaceUid, projectUid) {

        if (!workspaceUid)
            throw new Error('[WorkspaceManager]: "workspaceUid" is required.');
        if (!projectUid)
            throw new Error('[WorkspaceManager]: "projectUid" is required.');

        return this.delete(`${encodeURIComponent(workspaceUid)}/projects/${encodeURIComponent(projectUid)}`);

    }

    async get(path, query = null) {

        const response = await this.http.get(this.createPath(path), query, {
            responseType: 'json',
        });
        return response.payload;

    }

    async post(path, data) {

        const response = await this.http.post(this.createPath(path), data, {
            contentType: 'json',
            responseType: 'json',
        });
        return response.payload;

    }

    async delete(path) {

        const response = await this.http.delete(this.createPath(path), null, {
            responseType: 'json',
        });
        return response.payload;

    }

    createPath(path = '') {

        path = String(path ?? '').replace(/^\/+|\/+$/g, '');
        return path ? `${this.resourcePath}/${path}` : this.resourcePath;

    }

}
